/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryTree} from '../models/DictionaryTree';
import type {Error} from '../models/Error';

export interface GetSupportedAccountLogActions$Request {
    accountId: number;
}

export interface GetSupportedAccountLogActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedAccountLogActionsRequest = createAction<PayloadData<void, GetSupportedAccountLogActions$Request>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_ACCOUNT_LOG_ACTIONS__REQUEST');
export const getSupportedAccountLogActionsSuccess = createAction<PayloadData<Array<DictionaryTree>, GetSupportedAccountLogActions$Request>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_ACCOUNT_LOG_ACTIONS__SUCCESS');
export const getSupportedAccountLogActionsFailure = createAction<PayloadData<Error, GetSupportedAccountLogActions$Request, true>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_ACCOUNT_LOG_ACTIONS__FAILURE');

export const getSupportedAccountLogActionsActions = [
    getSupportedAccountLogActionsRequest,
    getSupportedAccountLogActionsSuccess,
    getSupportedAccountLogActionsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedAccountLogActions = (meta: GetSupportedAccountLogActions$Request, config?: GetSupportedAccountLogActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getSupportedAccountLogActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/account-audit-actions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSupportedUserLogActions$Request {
    userId: number;
}

export interface GetSupportedUserLogActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedUserLogActionsRequest = createAction<PayloadData<void, GetSupportedUserLogActions$Request>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_USER_LOG_ACTIONS__REQUEST');
export const getSupportedUserLogActionsSuccess = createAction<PayloadData<Array<DictionaryTree>, GetSupportedUserLogActions$Request>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_USER_LOG_ACTIONS__SUCCESS');
export const getSupportedUserLogActionsFailure = createAction<PayloadData<Error, GetSupportedUserLogActions$Request, true>>('AUDIT_LOG_DICTIONARY__GET_SUPPORTED_USER_LOG_ACTIONS__FAILURE');

export const getSupportedUserLogActionsActions = [
    getSupportedUserLogActionsRequest,
    getSupportedUserLogActionsSuccess,
    getSupportedUserLogActionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedUserLogActions = (meta: GetSupportedUserLogActions$Request, config?: GetSupportedUserLogActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        userId: meta.userId,
    };
    return {
        CALL_API: {
            types: getSupportedUserLogActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/user-audit-actions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

